import React, {useContext, useEffect, useState} from 'react'
import s from './styles/Discover.module.scss'
import SideBar from 'Components/Nav/SideBar';
import {isMentee, isMentor, SessionContext} from 'Utils/sessions';
import {Link} from 'react-router-dom';
import {CollegeCard, MentorCard} from 'Components/Tile/Card';
import {Root} from 'Root';
import Spinner from 'react-bootstrap/esm/Spinner'
import {Lightbox} from 'Components/Lightbox'
import {collegeIds} from "../../Utils/colleges";
import {DiscoverBlogCard} from "../../Components/Tile/Card";
import {getDeviceId, isLoggedIn} from "../../Utils/sessions";
import Footer from "../Landing/Footer";
import {NavBar} from "../../Components/Nav/NavBar";
import {useScroll} from "../../Utils/helpers";

export const BACKUP_COLLEGE = [
    {ipedsid: 152080, collegeName: 'University of Notre Dame'},
    {ipedsid: 110635, collegeName: 'University of California-Berkeley'},
    {ipedsid: 110653, collegeName: 'University of California-Irvine'},
    {ipedsid: 135726, collegeName: 'University of Miami'},
    {ipedsid: 166027, collegeName: 'Harvard'},
    {ipedsid: 110662, collegeName: 'University of California-Los Angeles'},
    {ipedsid: 217156, collegeName: 'Brown University'},
    {ipedsid: 139658, collegeName: 'Emory University'},
    {ipedsid: 123961, collegeName: 'University of Southern California'},
    {ipedsid: 170976, collegeName: 'University of Michigan-Ann Arbor'},
    {ipedsid: 215062, collegeName: 'University of Pennsylvania'},
    {ipedsid: 211440, collegeName: 'Carnegie Mellon University'},
    {ipedsid: 198419, collegeName: 'Duke University'}];

export const DiscoverPageDisplay = () => {
    const [searchBarPlaceHolder, setSearchBarPlaceholder] = useState('Search for anything related to college')
    const [searchSuggestions, setSearchSuggestions] = useState([]);
    const {session} = useContext(SessionContext);
    const isScrolled = useScroll(5)

    let counter = 0;

    const placeHolderOptions = [
        `Search for "a student studying computer science"`,
        `Search for "a junior at a college near me"`,
        `Search for "someone who's interested in art"`,
        `Search for "a student athlete"`,
        `Search for "someone who's also shy, like me"`]

    const onQueryChange = (newQuery) => {
        if (newQuery?.length > 0) {
            setSearchSuggestions(filterSchools(newQuery));
        } else {
            setSearchSuggestions([]);
        }
    }

    const filterSchools = (searchTerm) => {
        // Convert searchTerm to lowercase for case-insensitive matching
        const lowerCaseSearchTerm = searchTerm.toLowerCase();

        // Filter strings based on relevance
        const filteredStrings = collegeIds
            .filter(college => college.label.toLowerCase().includes(lowerCaseSearchTerm)) // Filter by inclusion
            .sort((a, b) => {
                // Calculate relevance score (simple example)
                const aScore = calculateRelevanceScore(a.label, lowerCaseSearchTerm);
                const bScore = calculateRelevanceScore(b.label, lowerCaseSearchTerm);
                return bScore - aScore; // Sort in descending order of relevance
            }).map(college => college.label);

        if (filteredStrings.length > 8) {
            return filteredStrings.slice(0, 7)
        }

        return filteredStrings;
    }

    const calculateRelevanceScore = (str, searchTerm) => {
        // Simple relevance score:
        // - Higher score for exact matches at the beginning
        // - Lower score for partial matches or matches later in the string
        if (str.toLowerCase().startsWith(searchTerm)) {
            return 10;
        } else if (str.toLowerCase().includes(searchTerm)) {
            return 5;
        } else {
            return 0;
        }
    }

    useEffect(() => {
        const intervalId = setInterval(() => {
            counter++;
            setSearchBarPlaceholder(placeHolderOptions[counter % 5]);
        }, 2000);

        return () => clearInterval(intervalId);
    }, []);

    if (isLoggedIn(session)) {
        return <>
            <SideBar session={session} title={"Discover"} placeholder={searchBarPlaceHolder}
                     suggestions={searchSuggestions}
                     onQueryChange={onQueryChange}>
                <div className={s.discoverContainer}>
                    <Discover searchBarPlaceHolder={searchBarPlaceHolder}/>
                </div>
            </SideBar>
        </>
    } else {
        return <>
            <div>
                <div className={`${s.navBarContainer} ${isScrolled ? s.navBarScrolled : ''}`}>
                    <NavBar dark={true}/>
                </div>
                <div className={`${s.blogsHeader}`}>
                    <div className={`${s.blogsHeaderText}`}>
                        <h1><strong>Discover</strong></h1>
                        <h3 className={s.subheader}>Everything you need to prepare you for the big decision</h3>
                    </div>
                </div>
                <div className={s.discoverPageContent}>
                    <Discover searchBarPlaceHolder={searchBarPlaceHolder}/>
                </div>
            </div>
            <Footer/>
        </>
    }
}

const Discover = ({searchBarPlaceHolder}) => {
    const {session} = useContext(SessionContext);
    const [students, setStudents] = useState([]);
    const [blogs, setBlogs] = useState(undefined);
    const [loadingStudents, setLoadingStudents] = useState(false);
    const [error, setError] = useState(null);
    const [colleges, setColleges] = useState(undefined)
    const [images, setImages] = useState(null)
    const [videos, setVideos] = useState(null)
    const [videoError, setVideoError] = useState(null)
    const [imageError, setImageError] = useState(null)
    const [photoIndex, setPhotoIndex] = useState(null)
    const [videoIndex, setVideoIndex] = useState(null)

    useEffect(() => {
        setStudents(null)
        setError(null)
        if (session.jwt) {
            setLoadingStudents(true)
            Root.userApi.findCollegeMentors({deviceId: getDeviceId()}, session.jwt).then((res) => {
                setStudents(res.data)
                setLoadingStudents(false)
            }).catch(() => {
                setStudents([])
                setLoadingStudents(false)
                setError("Please try again later")
            })
        } else {
            Root.userApi.getDisplayMentors({deviceId: getDeviceId()}).then((res) => {
                setStudents(res.data)
            }).catch(() => {
                setStudents([])
            })
        }
    }, [])

    useEffect(() => {
        if (isMentor(session)) {
            window.location.href = '/dashboard'
        }
    }, [])


    useEffect(() => {
        if (session.jwt) {
            Root.collegeApi.searchColleges(undefined, session.jwt)
                .then(res => setColleges(res.data))
                .catch(() => setColleges(BACKUP_COLLEGE))
        } else {
            Root.collegeApi.getDisplayColleges({deviceId: getDeviceId()})
                .then(res => setColleges(res.data))
                .catch(() => setColleges(BACKUP_COLLEGE))
        }
    }, [session?.jwt])

    useEffect(() => {
        if (isMentee(session)) {
            Root.collegeApi.getDiscoveryVideos(session.jwt).then((res) => {
                setVideos(res.data)
            }).catch((err) => {
                setVideos([])
                setVideoError("Please try again later")
            })
        }
    }, [])

    useEffect(() => {
        if (isMentee(session)) {
            Root.collegeApi.getDiscoveryImages(session.jwt).then((res) => {
                setImages(res.data)
            }).catch(() => {
                setImages([])
                setImageError("Please try again later")
            })
        }
    }, [])

    useEffect(() => {
        if (!isMentor(session)) {
            Root.bloggingApi.getBlogPosts({deviceId: getDeviceId()}, session.jwt).then((res) => {
                setBlogs(res.data)
            }).catch(() => {
                setBlogs([])
            })
        }
    }, [])

    return <>
        <div className={s.row}>
            {isLoggedIn(session) ?
                <h3 className='heading mb-0'>Discover Student Mentors</h3>
                :
                <>
                    <h1><strong>Discover Student Mentors</strong></h1>
                    <h3 className='heading mb-0'>{`College is a huge decision. You shouldn't have to make it alone.`}</h3>
                </>
            }
            <div className='horScroll'>
                {students ? students.map((s) => {
                        return <MentorCard mentor={s} className={`me-4 my-4`}
                                           onClick={() => window.location.href = (isMentor(s) ? `mentor/${s.userName}` : `/student/${s.userName}`)}/>
                    }) :
                    <>
                        <MentorCard className={`me-4 my-4`}/>
                        <MentorCard className={`me-4 my-4`}/>
                        <MentorCard className={`me-4 my-4`}/>
                        <MentorCard className={`me-4 my-4`}/>
                    </>
                }
                {!error && students && students.length === 0 && session.profile?.profile &&
                    <p>No students found</p>}
                {!error && students && students.length === 0 && session.jwt && !session.profile?.profile &&
                    <p className='text-muted fs-13'>Create your profile to view students <a
                        href={'/onboarding'}>here</a>.</p>}
                {!error && !session.jwt &&
                    <p className='text-muted fs-13'>Please <a href={'/login'}>login</a> to view more.</p>}
                {error && <p className='text-muted fs-13'>{error}</p>}
                {loadingStudents &&
                    <Spinner style={{color: "rgb(16, 142, 115)"}} animation="border" role="status"/>}
            </div>
        </div>
        {!isMentor(session) &&
            <>
                {blogs?.length > 0 &&
                    <div className={s.row}>
                        {isLoggedIn(session) ?
                            <Link className='btnLink' to="/blog">
                                <h3 className='heading mb-0'>Read Other's Opinions ></h3>
                            </Link>
                            :
                            <>
                                <Link className={'btnLink'} to="/blog">
                                    <h1><strong>Read Other's Opinions</strong></h1>
                                </Link>

                                <h3 className='heading mb-0'>{`College is a huge decision. You shouldn't have to make it alone.`}</h3>
                            </>
                        }
                        <div className='horScroll'>
                            {blogs ? blogs.map((blog, idx) => {
                                    return <DiscoverBlogCard key={idx} blog={blog}/>
                                }) :
                                <>
                                    <DiscoverBlogCard/>
                                    <DiscoverBlogCard/>
                                    <DiscoverBlogCard/>
                                    <DiscoverBlogCard/>
                                    <DiscoverBlogCard/>
                                </>}
                        </div>
                    </div>
                }
                {colleges?.length > 0 &&
                    <div className={`${s.row}`}>
                        {isLoggedIn(session) ?
                            <h3 className='heading mb-0'>Discover Colleges</h3>
                            :
                            <>
                                <h1><strong>Discover Colleges</strong></h1>
                                <h3 className='heading mb-0'>{`College is a huge decision. You shouldn't have to make it alone.`}</h3>
                            </>
                        }
                        <div className='horScroll'>
                            {colleges ? colleges.map((c, idx) => {
                                    return <CollegeCard college={c} className='my-4'/>
                                }) :
                                <>
                                    <CollegeCard className='my-4'/>
                                    <CollegeCard className='my-4'/>
                                    <CollegeCard className='my-4'/>
                                    <CollegeCard className='my-4'/>
                                    <CollegeCard className='my-4'/>
                                </>
                            }
                        </div>
                    </div>
                }
            </>
        }
        {isMentee(session) && <>
            {images && images.length > 0 &&
                <div className={s.row}>
                    <div className={s.dashboardContent}>
                        <h3 className='heading'>Recently Uploaded College Pics</h3>
                    </div>

                    <div className='horScroll'>
                        {imageError && <p className='text-muted fs-13'>{imageError}</p>}
                        {!images &&
                            <Spinner style={{color: "rgb(16, 142, 115)"}} animation="border" role="status"/>}
                        {images && images.map((img, idx) => <div className='d-inline-block my-4'
                                                                 style={{maxWidth: '275px'}}>
                                <img alt={img.caption || "image"}
                                     style={{height: '170px', width: '256px', objectFit: 'cover', borderRadius: '15px'}}
                                     className={`my-1 me-4 ${s.blogTile}`} src={img.url}
                                     onClick={() => setPhotoIndex(idx)}></img>
                                <p className='text-muted fs-13 m-0 p-0 trunc'>{img.collegeName}</p>
                            </div>
                        )}
                    </div>

                    {images && <Lightbox
                        contentList={images}
                        idx={photoIndex}
                        onHide={() => setPhotoIndex(null)}
                        setIdx={setPhotoIndex}
                    />}
                </div>
            }

            {videos && videos.length > 0 &&
                <div className={s.row}>
                    <h3 className='heading'>Recently Uploaded College Videos</h3>
                    <div className='horScroll'>
                        {videoError && <p className='text-muted fs-13'>{videoError}</p>}
                        {!videos &&
                            <Spinner style={{color: "rgb(16, 142, 115)"}} animation="border" role="status"/>}
                        {videos && videos.map((img, idx) => <div className='d-inline-block my-4'
                                                                 style={{maxWidth: '275px'}}>
                                <video alt={img.caption || "image"}
                                       style={{
                                           height: '170px',
                                           width: '256px',
                                           objectFit: 'cover',
                                           borderRadius: '15px'
                                       }}
                                       className={`my-1 me-4 ${s.blogTile}`} src={img.url} playsInline autoPlay loop
                                       muted
                                       onClick={() => setVideoIndex(idx)}/>
                                <p className='text-muted fs-13 me-4 p-0 trunc'>{img.caption}</p>
                            </div>
                        )}
                    </div>
                    {videos && <Lightbox
                        contentList={videos}
                        idx={videoIndex}
                        onHide={() => setVideoIndex(null)}
                        setIdx={setVideoIndex}
                    />}
                </div>
            }
        </>}
    </>
}

export default (Discover);
